<template>
  <div id="claim-expired">
    <div class="hero">
      <img src="@/assets/icon-clock.png" />
      <h1>คุณไม่ได้ยืนยันสิทธิ์<br />ภายในเวลาที่กำหนด</h1>
    </div>
    <p class="body">
      หากมีข้อสงสัยกรุณาติดต่อ น้องจริงใจ<br />
      ที่ <a href="https://th.pmiandu.com/s">LINE VIP by PMTT</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "ClaimExpired",
};
</script>

<style lang="scss" scoped>
#claim-expired {
  width: 100%;
  height: 100%;
  position: relative;

  color: #ffffff;
  text-align: center;

  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url("~@/assets/images/Background.png");

  .hero {
    top: 10%;
    position: relative;

    img {
      margin-bottom: 1rem;
    }

    h1 {
      font-size: 2rem;
    }
  }

  .body {
    color: #333;
    line-height: 1;
    font-size: larger;
    font-weight: normal;

    top: 30%;
    position: relative;
  }
}
</style>
